import { render, staticRenderFns } from "./bannedList.vue?vue&type=template&id=428ec2d7&scoped=true"
import script from "./bannedList.vue?vue&type=script&lang=js"
export * from "./bannedList.vue?vue&type=script&lang=js"
import style0 from "./bannedList.vue?vue&type=style&index=0&id=428ec2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ec2d7",
  null
  
)

export default component.exports